"use client";
import { fetchGeneralSetting } from "@/redux/slices/settingSlice";
import { fetchTeacherInfo } from "@/redux/slices/teacherSlice";
import { fetchUserInfo } from "@/redux/slices/userSlice";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";


export default function useInitialDispatch() {
  const dispatch = useDispatch();
  const hasDispatched = useRef(false);

  useEffect(() => {
    if (hasDispatched.current) return;
    hasDispatched.current = true;
    dispatch(fetchUserInfo());
    dispatch(fetchTeacherInfo());
    dispatch(fetchGeneralSetting());
    
  }, [dispatch]);
}
